import { postRequest } from "./postRequest";

export type AttrFilter = Record<string, string[]>;

export type SearchReq = {
  q?: string;
  categoryId?: number;
  minPrice?: number;
  maxPrice?: number;
  attr?: AttrFilter;
  sort?: "new" | "price_asc" | "price_desc";
  page?: number;
  pageSize?: number;
};

export type ProductCard = {
  id: number;
  ad: string;
  fiyat: number;
  paraBirimi: string;
  fotoMain?: string | null;
  fotoList: string[];
  satisFiyati?: number | null;
  listeFiyati?: number | null;
  indirimliFiyat?: number | null; // istersen kullanırsın, burada göstermiyorum
  indirimAktifMi?: boolean;
  oneCikanmi?: boolean;
  stokAdedi?: number;

};

export type FacetValue = { value: string; count: number };
export type Facet = { name: string; values: FacetValue[] };

export type SearchResp = {
  items: ProductCard[];
  total: number;
  page: number;
  pageSize: number;
  facets: Facet[];
};

export async function searchProducts(req: SearchReq) {
  return postRequest<SearchReq, { success: boolean; data?: SearchResp; errorDetail?: string }>(
    "/Urunler/ara",
    {
      Q: req.q,
      CategoryId: req.categoryId,
      MinPrice: req.minPrice,
      MaxPrice: req.maxPrice,
      Attr: req.attr,
      Sort: req.sort,
      Page: req.page ?? 1,
      PageSize: req.pageSize ?? 24,
    } as any
  );
}

export async function suggestProducts(q: string) {
  return postRequest<{ q: string }, { success: boolean; data?: ProductCard[]; errorDetail?: string }>(
    "/Urunler/oner",
    { q }
  );
}

export async function getProductDetail(id: number) {
  return postRequest<{ id: number }, { success: boolean; data?: any; errorDetail?: string }>(
    "/Urunler/detay",
    { id }
  );
}
